import { useEffect, useId, useRef, useState } from 'react';

export default function ReportExportMenu({ onPrint, unavailableReason = 'Load a complete authorized statement first.' }: {
  onPrint?: () => void; unavailableReason?: string;
}) {
  const [open, setOpen] = useState(false);
  const [failed, setFailed] = useState(false);
  const root = useRef<HTMLDivElement>(null);
  const trigger = useRef<HTMLButtonElement>(null);
  const id = useId();
  useEffect(() => {
    if (!open) return;
    const keydown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') { setOpen(false); trigger.current?.focus(); }
    };
    const outside = (event: PointerEvent) => {
      if (event.target instanceof Node && !root.current?.contains(event.target)) setOpen(false);
    };
    document.addEventListener('keydown', keydown);
    document.addEventListener('pointerdown', outside);
    return () => { document.removeEventListener('keydown', keydown); document.removeEventListener('pointerdown', outside); };
  }, [open]);
  const disabled = (title: string, reason: string) => <div className="re-option">
    <button type="button" disabled>{title}</button><small>{reason}</small>
  </div>;
  return <div className="report-export" ref={root}>
    <button className="wc-retry" ref={trigger} type="button" aria-expanded={open} aria-controls={id}
      onClick={() => setOpen((value) => !value)}>Export ▾</button>
    {open && <div className="re-options" id={id} role="group" aria-label="Export options">
      <h3>This report, with the filters as set</h3>
      <div className="re-option"><button type="button" disabled={!onPrint} onClick={() => {
        if (!onPrint) return;
        setOpen(false); setFailed(false);
        try { onPrint(); } catch { setFailed(true); }
      }}>PDF · Print / Save as PDF</button>
        <small>{onPrint ? 'Opens your browser print dialog with the filtered statement and basis of preparation. Choose Save as PDF.' : unavailableReason}</small>
      </div>
      {disabled('PowerPoint', 'Unavailable: editable chart and table export is not implemented.')}
      {disabled('Excel', 'Unavailable: scoped GL Detail and auditable formula export are not implemented.')}
      <h3>Full financial package</h3>
      {disabled('Package · Excel', 'Unavailable: P&L, balance sheet, cash flow, variance and GL-detail contracts are incomplete.')}
      {disabled('Package · PDF', 'Unavailable: the full three-statement package is not implemented.')}
    </div>}
    {failed && <p role="alert">The print dialog could not be opened. No export was confirmed.</p>}
  </div>;
}
